import Entrepreneurs from '@/components/entrepreneur/Entrepreneurs'
import CreateEntrepreneur from '@/components/entrepreneur/CreateEntrepreneur'
import Enum from '@/shared/enum'

let entrepreneursRoutes = [
  {
    meta: {
      title: 'menu.entrepreneurs',
      ico: 'briefcase',
      permission: ['Pages.Entrepreneurs'],
    },
    path: '/entrepreneurs',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'entrepreneurs',
        path: '',
        meta: {permission: ['Pages.Entrepreneurs.View']},
        component: Entrepreneurs,
      },
      {
        name: 'entrepreneurs_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE},
        meta: {permission: ['Pages.Entrepreneurs.Create']},
        component: CreateEntrepreneur,
      },
      {
        name: 'entrepreneurs_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Entrepreneurs.Create']},
        component: CreateEntrepreneur,
      },
      {
        name: 'entrepreneurs_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Entrepreneurs.View']},
        component: CreateEntrepreneur,
      },
      {
        name: 'entrepreneurs_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Entrepreneurs.Create']},
        component: CreateEntrepreneur,
      },
    ],
  },
]

export default entrepreneursRoutes



// WEBPACK FOOTER //
// ./src/router/entrepreneurs.js